import { Autocomplete } from '@material-ui/lab';
import { InputLabel, TextField } from '@material-ui/core';
import { useField } from 'formik';

/**
 * Base component for async autocomplete fields
 * Behaves asynchronously
 */
const CustomAutoComplete = ({
  name,
  label,
  placeholder,
  options,
  isDisabled = false,
  onChange,
  ...otherProps
}) => {
  const [field, meta] = useField({ name, ...otherProps });

  const TextFieldProps = {
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
    placeholder,
    FormHelperTextProps: {
      className: 'mx-4 mt-2 text-12'
    }
  };

  if (meta && meta.touched && meta.error) {
    TextFieldProps.error = true;
    TextFieldProps.helperText = meta.error;
  }

  const handleChange = (e, val) => {
    onChange && onChange(name, val);
  };

  return (
    <>
      <InputLabel htmlFor={name} className="mb-8 text-gray-700 font-semibold">
        {label}
      </InputLabel>

      <Autocomplete
        {...field}
        {...otherProps}
        options={options || []}
        loading
        ListboxProps={{
          style: {
            maxHeight: '200px'
          }
        }}
        loadingText="Seçenekler Yükleniyor..."
        disableListWrap
        onChange={handleChange}
        noOptionsText="Seçenek Yok..."
        getOptionLabel={option => `${option.label || ''}`}
        getOptionSelected={(opt, list) => opt.value === list.value}
        renderOption={option => <>{option.label || ''}</>}
        renderInput={params => <TextField {...params} {...TextFieldProps} />}
      />
    </>
  );
};

export default CustomAutoComplete;
